import { useMutation, useQueryClient } from 'react-query';
import { useTranslation } from 'react-i18next';
import { dataFetch, DIGGER_API_SUFFIX } from '../../../axios/customAxios';
import { handleApiError } from '../../requestHelpers/requestHelpers';
import { ORGANIZATION_SETTINGS } from '../../../constants/pageIdentifiers';

export const useMicrosoftCode = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  return useMutation(
    (code: string) => dataFetch.post(
      `${DIGGER_API_SUFFIX}microsoft/initiate`,
      {
        code,
      },
    ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(ORGANIZATION_SETTINGS);
      },
      onError: (error: any) => {
        handleApiError(error, t);
      },
    },
  );
};
